const config = {
  development: {
    //baseURL: "http://127.0.0.1:10510"
    baseURL: "https://uh-courses.fly.dev/"
  },
  beta: {
    baseURL: "http://192.168.3.9:10510"
  },
  production: {
    baseURL: "https://uh-courses.fly.dev/"
  }
};

export default config;
